/* @flow strict */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';
import IntegrationsCalendarThemeModal from './themeModal';
import IntegrationsCalendarPreviewModal from './previewModal';
import CodeCard from '/client/src/components/panel/codeCard';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';
import Switcher from '/client/src/components/switcher';
import Loader from '/client/src/components/Loader';
import { PUT } from '/client/src/api/';
import CssPinner from '/client/src/components/csspinner';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  }
};

const items = [
  {
    link: '',
    label: 'Embed'
  }
];

const IntegrationsCalendar = ({ match }: PropsType): React.Element<'div'> => {
  const {
    params: { viewTab }
  } = match;
  const context = React.useContext(DefaultContainerContext);
  const _viewTab = viewTab ? viewTab.toLowerCase() : '';
  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`IntegrationsCalendar-menuItems-${k}`}
        className={`${_viewTab === i.link ? 'active' : ''}`}
      >
        <Link to={`/integrations/calendar/${i.link}`}>{i.label}</Link>
      </li>
    );
  });
  const currentTheme = context.profileCurrent.calendar_theme || 'Classic';

  const [isOpen, handleToggleModal] = React.useState(false);
  const [isOpenPreview, handleTogglePreviewModal] = React.useState(false);
  const [IsCheckSwitcher, isToggleCheckSwitcher] = React.useState(false);
  const [calendarTheme, setCalendarTheme] = React.useState(currentTheme);

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          const status = _.get(response.data.result, 'is_enable_calendar_iframe_comp_mode', false);

          isToggleCheckSwitcher(status);
        } catch (e) {
          // console.error('cant get events list');
          context.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Error!',
            systemDialogContent: 'Error'
          });
        }
      }
    },
    []
  );

  const requestToChangeSwitcherStatus = async (status: boolean) => {
    try {
      CssPinner(document.body, true);

      await PUT('/api/v1/1/merchants/calendar_settings', {
        is_enable_calendar_iframe_comp_mode: status
      });

      isToggleCheckSwitcher(status);

      CssPinner(document.body, false);
    } catch (e) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t enable iframe mode'
      });

      isToggleCheckSwitcher(false);

      CssPinner(document.body, false);
    }
  };

  return (
    <div className="IntegrationsCalendar">
      <NavbarTitleBackAction />

      <div className="sparxo-router-content">
        <div className="sparxo-page-container">
          <div className="event-list">
            <div className="facebook-page">
              <div className="sparxo-integrations-cards">
                <div
                  className="sparxo-integrations-list"
                  style={{ marginTop: 0 }}
                >
                  <div
                    className="sparxo-integrations-item"
                    style={{
                      background: 'none',
                      maxWidth: '360px',
                      margin: '0 auto'
                    }}
                  >
                    <div className="media">
                      <div className="media-left">
                        <img
                          src={'/img/code.png'}
                          alt="cards"
                          className="media-object"
                        />
                      </div>

                      <div className="media-body">
                        <h4 className="media-heading" style={{ fontWeight: 0 }}>
                          Sparxo Calendar
                        </h4>

                        <span>Add Sparxo Calendar to your website</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-center" style={{ marginBottom: '20px' }}>
                Sell tickets directly on your site by integrating Sparxo
                Calendar
              </p>

              <div className="panel panel-default panel-page">
                <div className="navbar-page-toolbar customers-navbar code-navbar">
                  <div className="container-fluid" style={{ height: '50px' }}>
                    <ul className="nav">{menuItems}</ul>
                  </div>
                </div>
              </div>

              <CodeCard
                title="Calendar"
                customize
                handleToggleThemeModal={handleToggleModal}
                handleTogglePreviewModal={handleTogglePreviewModal}
                imageClass="calendar"
                content={`<div class="sparxo-nest-calendar sparxo-theme-classic sparxo-id-${context.profileCurrent.id} "></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}/assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, "script", "sparxo-js"));</script>`}
                additionalContent={
                  <div className="panel-heading" style={{ padding: '30px 0' }}>
                  <div className="panel-title">
                    <span className="text">
                      CALENDAR SETTINGS
                    </span>
                  </div>
                  <div className="panel-body">
                    <div
                      className="1input-group clearfix"
                      style={{
                        marginTop: '1rem',
                        width: '100%',
                        maxWidth: '285px',
                        position: 'relative'
                      }}
                    >
                      <Loader
                        url={`/api/v1/1/merchants/${context.profileCurrent.id}/events_calendar`}
                        onLoaded={handleLoaded}
                      >
                        <Switcher
                          className='form-switcher-sm pull-left mb1rem'
                          id='cardListSettings'
                          name='cardListSettings'
                          index='cardListSettings'
                          checked={IsCheckSwitcher}
                          onCallback={(e: any, status: boolean) => {
                            requestToChangeSwitcherStatus(status);
                          }}
                          label='Enable iframe compatibility mode'
                        />
                      </Loader>
                    </div>
                  </div>
                </div>
                }
              />
            </div>
          </div>
        </div>
      </div>

      {isOpen ? (
        <IntegrationsCalendarThemeModal
          isOpen={isOpen}
          handleToggleModal={handleToggleModal}
          calendarTheme={calendarTheme}
          setCalendarTheme={setCalendarTheme}
        />
      ) : null}

      {isOpenPreview ? (
        <IntegrationsCalendarPreviewModal
          isOpen={isOpenPreview}
          handleToggleModal={handleTogglePreviewModal}
        />
      ) : null}
    </div>
  );
};

export default withRouter(IntegrationsCalendar);
